import React from 'react';

const CompleteStep = ({ onFinish }) => {
  return (
    <div className="text-center">
      <div className="text-6xl mb-6">🎉</div>
      <h2 className="text-3xl font-bold text-gray-900 mb-4">You're All Set!</h2>
      <p className="text-lg text-gray-600 mb-8">
        Your Apprecio workspace is ready. Start building a culture of recognition!
      </p>

      <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6 mb-8 text-left max-w-md mx-auto">
        <h3 className="text-lg font-semibold text-gray-800 mb-3">Quick Tips:</h3>
        <ul className="space-y-2 text-gray-700">
          <li>• Send your first appreciation to celebrate someone's work</li>
          <li>• Check the leaderboard to see top recognizers</li>
          <li>• Earn badges by building a positive culture</li>
          <li>• Invite more team members anytime from User Management</li>
        </ul>
      </div>

      <button
        onClick={onFinish}
        className="px-8 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium text-lg"
      >
        Go to Dashboard
      </button>
    </div>
  );
};

export default CompleteStep;
